// ----------------------------------------------------------------------------
// Component: Expandable Cards
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------


// Styles
import './_expandable-cards.scss';
import '../../snippets/_containers/css-grid/css-grid'

import $ from 'jquery';


// Constant elements
const TOGGLE_BUTTON = '.css-grid__item--card';
const TOGGLE_CONTENT = '.css-grid__item--panel';

// Constant trigger classes
const OPEN_CLASS = 'js-active';

// Open first tab on page load
$('.expandable-cards').each(function(index) {
    $(this).children(TOGGLE_BUTTON).first().addClass(OPEN_CLASS);
    $(this).children(TOGGLE_CONTENT).first().addClass(OPEN_CLASS);
});

function tabOpen(tab) {
    const $panel = tab.next(TOGGLE_CONTENT);
    const hash   = '#' + $panel.attr('id');

    // Close all other Panels
    tab.siblings().removeClass(OPEN_CLASS);

    // Toggle the Current Panel
    if (tab.hasClass(OPEN_CLASS)) {
        if($(window).width() < 1025) {
            tab.removeClass(OPEN_CLASS);
            $panel.removeClass(OPEN_CLASS);
        }else{
            tab.addClass(OPEN_CLASS);
            $panel.addClass(OPEN_CLASS);
        }
    } else {
        tab.addClass(OPEN_CLASS);
        $panel.addClass(OPEN_CLASS);

        // Add the hash  to the URL
        if (history.pushState) {
            history.pushState(null, null, hash);
        } else {
            location.hash = hash;
        }

        if($(window).width() < 1025) {
            // // Scroll to the Panel portion when opening
            $('html, body').animate({
                scrollTop: $panel.offset().top - 180
            }, 500);
        }
    }
}

// Card opens Panel
$(TOGGLE_BUTTON).on('click', function(event) {
    tabOpen($(this));
});

// Accessibility keypress opens Panel
$(TOGGLE_BUTTON).keypress(function(event) {
    if (event.which == 13) {
        tabOpen($(this));
    }
});

// Close Button Closes Panel
$('.css-grid__item-close').on('click', function(event) {
    var $card  = $(this).parents('.css-grid__item').prev('.css-grid__item--card');
    var $panel = $(this).parents('.css-grid__item--panel');

    // Close the relevant panel
    $card.removeClass(OPEN_CLASS);
    $panel.removeClass(OPEN_CLASS);
});
